function EmptyData({ Message }) {
    return (
        <div className="flex items-center w-full justify-center min-h-screen">
            <h1 className="text-xl font-bold text-white">{Message}</h1>
        </div>
    );
}

export default EmptyData
